import { jsxs as o, jsx as e } from "react/jsx-runtime";
import { useState as t } from "react";
import r from "../../../assets/CopyIcon.svg.js";
import { useTheme as i } from "@mui/joy";
import l from "@mui/joy/Stack";
import a from "@mui/joy/Tooltip";
import n from "@mui/joy/Typography";
import { copyTextToClipboard as p } from "./utils.js";
const m = ({ label: m2 = "ID", value: s, hasPrefix: c = true, hideValue: u = false }) => {
  const [d, f] = t(false), h = { bgcolor: i().palette.isDarkMode ? "neutral.200" : "neutral.100", py: 0.5, px: 1 };
  return o(l, { gap: u && !c ? 0 : 0.5, sx: { flexDirection: "row", alignItems: "center", fontSize: "sm", borderRadius: "8px", gap: 0.5, ...c && h }, children: [o(n, { component: "span", level: "body-sm", sx: { color: (o2) => o2.palette.neutral[700] }, children: [c && `${m2} - `, !c && !!m2 && e(n, { fontWeight: "bold", sx: { color: (o2) => o2.palette.neutral[800] }, children: m2 }), !u && e(n, { className: "copy-text__value", component: "b", fontWeight: "bold", sx: { color: (o2) => o2.palette.neutral[800] }, children: s })] }), e(a, { title: d ? "Скопійовано" : "Скопіювати", placement: "right", arrow: true, sx: { cursor: "pointer" }, children: e(l, { children: e(r, { onClick: async (o2) => {
    o2.stopPropagation(), await p(s), f(true), setTimeout(() => {
      f(false);
    }, 1e3);
  } }) }) })] });
};
export {
  m as CopyText,
  m as default
};
//# sourceMappingURL=CopyText.js.map
